import { setCoins } from "./coins";

setCoins()